/*
  <kl-video>: shows a poster image with a play button and only loads the
  YouTube/Vimeo player (from its <template>) when clicked. Keeps pages with
  many videos fast. Used by sections/kl-video-grid.liquid.
*/
if (!customElements.get('kl-video')) {
  customElements.define(
    'kl-video',
    class KlVideo extends HTMLElement {
      connectedCallback() {
        const poster = this.querySelector('.kl-video__poster');
        if (!poster || poster.dataset.bound) return;
        poster.dataset.bound = 'true';
        poster.addEventListener('click', () => this.play());
      }

      play() {
        const template = this.querySelector('template');
        const frame = this.querySelector('.kl-video__frame');
        if (!template || !frame) return;
        frame.replaceChildren(template.content.cloneNode(true));
        const iframe = frame.querySelector('iframe');
        if (iframe) iframe.focus();
      }
    }
  );
}
